import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { forgotPasswordService } from "../api/services";
import { useRequestError } from "../hooks/useRequestError";

const GENERIC_SUCCESS_MESSAGE =
  "If your email is registered, you will receive a password reset link.";

export const ForgotPasswordPage = () => {
  const { handleRequestError } = useRequestError();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault();
    const normalized = email.trim().toLowerCase();
    if (!normalized.includes("@")) {
      return;
    }
    setSubmitting(true);
    setSuccessMessage(null);
    try {
      const response = await forgotPasswordService(normalized);
      setSuccessMessage(
        (response as { message?: string })?.message || GENERIC_SUCCESS_MESSAGE
      );
    } catch (error) {
      handleRequestError(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <img src="/logo.png" alt="REEVA" className="auth-logo" />
        <h1>Reset Your Password</h1>
        <p className="muted center">
          Enter the email linked to your account and we will send you a reset
          link.
        </p>
        {successMessage ? (
          <div className="banner success">{successMessage}</div>
        ) : null}
        <form className="stack gap-md" onSubmit={onSubmit}>
          <label className="field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setSuccessMessage(null);
              }}
              required
            />
          </label>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? "Sending…" : "Send reset link"}
          </button>
        </form>
        <Link to="/login" className="center-link">
          Back to login
        </Link>
      </div>
    </div>
  );
};
